// extracted by mini-css-extract-plugin
export var compact = "DashboardMenu-module--compact--mc1l5";
export var content = "DashboardMenu-module--content--6fSEP";
export var description = "DashboardMenu-module--description--MHvAK";
export var icon = "DashboardMenu-module--icon--LSHz7";
export var link = "DashboardMenu-module--link--BRxa+";
export var list = "DashboardMenu-module--list--usMME";
export var primary = "DashboardMenu-module--primary--WxaHc";
export var secondary = "DashboardMenu-module--secondary--d-q61";
export var symbol = "DashboardMenu-module--symbol--rsRIy";
export var title = "DashboardMenu-module--title--kosmw";